import { defineMessages } from "react-intl";

// The phrasing mirrors the legacy shared-ui AIR list (`utils/airs/resource-items/message-definitions.ts`)
// but the IDs are scoped to this section as copy will diverge in the future for the get started page
export const MESSAGES = defineMessages({
  bankStatementsTitle: {
    id: "funding-application: air list next bank statements title",
    defaultMessage: "Upload your bank statements",
  },
  bankStatementsSubtextWithMask: {
    id: "funding-application: air list next bank statements subtext with mask",
    defaultMessage: "{bankName} account ending in {accountMask}, {periods}",
  },
  bankStatementsSubtext: {
    id: "funding-application: air list next bank statements subtext",
    defaultMessage: "{bankName} account(s), {periods}",
  },
  bankStatementsDefaultBankName: {
    id: "funding-application: air list next bank statements default bank name",
    defaultMessage: "Bank",
  },
  bankStatementsPeriodText: {
    id: "funding-application: air list next bank statements period text",
    defaultMessage: "{dateFrom} to {dateTo}",
  },
  revenueSourceTitle: {
    id: "funding-application: air list next revenue source title",
    defaultMessage: "Additional eCommerce connection required",
  },
  revenueSourceMixedSubtext: {
    id: "funding-application: air list next revenue source mixed subtext",
    defaultMessage:
      "For {startPeriod} to {endPeriod} and with average monthly revenue of over {thresholdAmount} over the last {period}",
  },
  revenueSourceInsufficientRevenueSubtext: {
    id: "funding-application: air list next revenue source insufficient revenue subtext",
    defaultMessage: "Average monthly revenue of over {thresholdAmount} over the last {insufficientPeriod} months",
  },
  revenueSourceMissingPeriodSubtext: {
    id: "funding-application: air list next revenue source missing period subtext",
    defaultMessage: "For {startPeriod} to {endPeriod}",
  },
  revenueSourceDefaultSubtext: {
    id: "funding-application: air list next revenue source default subtext",
    defaultMessage: "Connect an additional revenue platform",
  },
  reconnectConnectionTitle: {
    id: "funding-application: air list next reconnect connection title",
    defaultMessage: "Reconnect your {platform}",
  },
  reconnectBankNoMaskSubtext: {
    id: "funding-application: air list next reconnect bank no mask subtext",
    defaultMessage: "Please reconnect your {bankName} bank.",
  },
  reconnectBankSingleMaskSubtext: {
    id: "funding-application: air list next reconnect bank single mask subtext",
    defaultMessage: "Please reconnect your {bankName} bank with account ending in {singularMask}.",
  },
  reconnectBankMultiMaskSubtext: {
    id: "funding-application: air list next reconnect bank multi mask subtext",
    defaultMessage: "Please reconnect your {bankName} bank with accounts ending in {maskList} and {maskListFinal}.",
  },
  reconnectPlatformWithIdentifierSubtext: {
    id: "funding-application: air list next reconnect platform with identifier subtext",
    defaultMessage: "Please reconnect your {platform} account: {identifier}",
  },
  reconnectPlatformSubtext: {
    id: "funding-application: air list next reconnect platform subtext",
    defaultMessage: "Please reconnect your {platform} account.",
  },
  defaultTitle: {
    id: "funding-application: air list next default title",
    defaultMessage: "Additional information requested",
  },
  defaultSubtext: {
    id: "funding-application: air list next default subtext",
    defaultMessage: "Action required",
  },
  bankStatementsTimeEstimate: {
    id: "funding-application: air list next bank statements time estimate",
    defaultMessage: "Avg. 1 min",
  },
  revenueSourceTimeEstimate: {
    id: "funding-application: air list next revenue source time estimate",
    defaultMessage: "Avg. 2 mins",
  },
  reconnectConnectionTimeEstimate: {
    id: "funding-application: air list next reconnect connection time estimate",
    defaultMessage: "Avg. 2 mins",
  },
  bankStatementsCta: {
    id: "funding-application: air list next bank statements cta",
    defaultMessage: "Upload statements",
  },
  reconnectConnectionCta: {
    id: "funding-application: air list next reconnect connection cta",
    defaultMessage: "Reconnect",
  },
  revenueSourceCta: {
    id: "funding-application: air list next revenue source cta",
    defaultMessage: "Connect store",
  },
  defaultCta: {
    id: "funding-application: air list next default cta",
    defaultMessage: "View",
  },
  completedTag: {
    id: "funding-application: air list next completed tag",
    defaultMessage: "Completed",
  },
  connectedPlatformWithIdentifier: {
    id: "funding-application: air list next connected platform with identifier",
    defaultMessage: "Connected {connectorName} platform: {connectorIdentifier}",
  },
  connectedPlatformWithoutIdentifier: {
    id: "funding-application: air list next connected platform without identifier",
    defaultMessage: "Connected {connectorName} platform",
  },
  responseSupersededLabel: {
    id: "funding-application: air list next response superseded label",
    defaultMessage: "This request has been completed automatically. No further action is required at this time.",
  },
  responseReasonLessThan180Days: {
    id: "funding-application: air list next response reason less than 180 days",
    defaultMessage: "My eCommerce company is less than 6 months old",
  },
  responseReasonPreviousCompanyDecommissioned: {
    id: "funding-application: air list next response reason previous company decommissioned",
    defaultMessage: "My previous eCommerce company has been decommissioned",
  },
  responseReasonNoOtherPlatforms: {
    id: "funding-application: air list next response reason no other platforms",
    defaultMessage: "I don’t have other eCommerce platforms",
  },
  responseReasonPlatformDecommissioned: {
    id: "funding-application: air list next response reason platform decommissioned",
    defaultMessage: "My previous {platformType} has been decommissioned",
  },
  responseBankStatementsProvided: {
    id: "funding-application: air list next response bank statements provided",
    defaultMessage: "Bank statements uploaded",
  },
  responseBankAccountClosedWithMask: {
    id: "funding-application: air list next response bank account closed with mask",
    defaultMessage: "Account ending in {accountMask} closed on {closeDate}",
  },
  responseBankAccountClosedNoMask: {
    id: "funding-application: air list next response bank account closed no mask",
    defaultMessage: "Bank account closed on {closeDate}",
  },
  manualAirTitle: {
    id: "funding-application: air list next manual air title",
    defaultMessage: "Your application is on hold",
  },
  manualAirDescriptionSelfServe: {
    id: "funding-application: air list next manual air description self serve",
    defaultMessage: "Wayflyer has sent you an email with more information on how to progress your application.",
  },
  manualAirDescriptionRepOwned: {
    id: "funding-application: air list next manual air description rep owned",
    defaultMessage:
      "Your Wayflyer Sales representative will be in contact with you to further progress your application.",
  },
  manualAirTag: {
    id: "funding-application: air list next manual air tag",
    defaultMessage: "On hold",
  },
});
